import React, { useEffect, useState } from "react";
import { FaBuilding } from "react-icons/fa";
import {
  BsDiagram3Fill,
  Bs1CircleFill,
  Bs2CircleFill,
  Bs3CircleFill,
  Bs4CircleFill,
  Bs5CircleFill,
  Bs6CircleFill,
  Bs7CircleFill,
  Bs8CircleFill,
  Bs9CircleFill,
  Bs0CircleFill,
} from "react-icons/bs";
import { BsPersonSquare } from "react-icons/bs";
import { MdWorkHistory } from "react-icons/md";
import { MdAccountBox } from "react-icons/md";
import { Box, Icon, Typography } from "@mui/material";
import dayjs from "dayjs";
import genericUser from "../../../../assets/images/genericUser.jpg";
import { useTemplateController } from "context";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import styled from "@emotion/styled";
import { color } from "d3";

const styles = {
  nodeContainer: {
    minHeight: "175px",
    maxWidth: "400px",
    backgroundColor: "#ffffff",
    color: "#6691c4",
    display: "flex",
    flexDirection: "column",
    // justifyContent: "center",
    justifyContent: "space-between",
    borderRadius: "0.5rem",
    border: "1px solid #87cdef",
    padding: "0.5rem 1rem",
  },

  nodeContent: {
    //container principale
    display: "flex",
    alignItems: "start",
    gap: "10px",
    // marginBottom: "0.25rem"
  },
  imgContainer: {
    display: "flex",
    direction: "column",
    height: "8rem",
  },
  nodeTeam: {
    width: "100%",
    textAlign: "center",
  },
  nodeTeamName: {
    marginBottom: "0.5rem",
    color: "#87cdef",
    fontSize: "1.5rem",
  },
  nodeTeamMemberImg: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    margin: "0.2rem",
  },
  nodeImg: {
    //dimensione effettiva immagine
    width: "50px",
    height: "50px",
    borderRadius: "50%",
  },
  nodeInfo: {
    // marginLeft: "1rem",
    color: "#6691c4",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    gap: "0.5rem",
    width: "100%",
  },
  nodeName: {
    // paddingBottom: "0.3rem",
    fontSize: "20px",
    fontWeight: "bold",
  },
  nodeRole: {
    // paddingBottom: "0.5rem",
    fontSize: "17px",
  },
  nodeJobFunction: {
    fontSize: "14px",
  },
  nodeDepartment: {
    padding: "0.5rem",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#d77900",
    borderRadius: "1rem",
    color: "#ffffff",
  },
  icon: {
    marginRight: "0.5rem",
  },
  diagramIcon: {
    display: "flex",
    justifyContent: "right",
    gap: 2,
  },
  layerIcon: {
    position: "relative",
    width: "25px",
    height: "25px",
  },
  sensibleInfoBox: {
    fontSize: "14px",
    display: "flex",
    // margin: "0.5rem 0 0 0",
    justifyContent: "start",
    alignItems: "end",
    gap: "1rem",
  },
  iconBox: {
    display: "flex",
    justifyContent: "start",
    alignItems: "end",
    gap: "0.5em",
  },
  layersIcon: {
    fontSize: "large !important",
  },
  // iconText: {
  //   marginLeft: "0.5rem",
  // },
  gradeReportsBox: {
    fontSize: "14px",
    display: "flex",
    // height: "2em",
    // margin: "0.5rem 0",
    padding: "0 0 0.5em 0",
    // justifyContent: "space-between",
    alignItems: "end",
    gap: "1rem",
  },
  diagramIconBox: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    gap: "0.5em",
    color: "#00449e",
  },
};

const Circle0 = styled(Bs0CircleFill)`
  transform: scale(1);
`;

const Circle1 = Circle0.withComponent(Bs1CircleFill);
const Circle2 = Circle0.withComponent(Bs2CircleFill);
const Circle3 = Circle0.withComponent(Bs3CircleFill);
const Circle4 = Circle0.withComponent(Bs4CircleFill);
const Circle5 = Circle0.withComponent(Bs5CircleFill);
const Circle6 = Circle0.withComponent(Bs6CircleFill);
const Circle7 = Circle0.withComponent(Bs7CircleFill);
const Circle8 = Circle0.withComponent(Bs8CircleFill);
const Circle9 = Circle0.withComponent(Bs9CircleFill);

const CustomNodeContent = (props) => {
  const {
    data,
    orgData = [],
    modifiedNodeIds,
    isPrivateHidden,
    privateVisibilityData,
    //highlightedUser,
  } = props;
  //data rappresenta il singolo nodo dell'organigramma
  // const directReportsCount = Array.isArray(_children) ? _children.length : 0; // -->rappresenta solo i figli attualmente visibili
  let isExporting = false;
  // try{
  //     const [controller]=useTemplateController();
  //     isExporting=controller.isExporting
  // }catch(error){
  //   console.log(error)
  // }

  const directReportsCount = orgData
    ? orgData.filter((node) => node.parentId === data.id).length
    : 0; //calcola il numero di figli

  // Old get Indirect reports count -- It gets slower when data is a very long array -- Kept for a possible rollout
  // const getIndirectReportsCount = (id, data) => {
  //   const children = data.filter((node) => node.parentId === id);
  //   return children.reduce((acc, child) => {
  //     return acc + 1 + getIndirectReportsCount(child.id, data);
  //   }, 0);
  // };

  const getIndirectReportsCount = (id, data) => {
    // Build a lookup map once: O(n)
    const childrenMap = new Map();

    for (const node of data) {
      if (!childrenMap.has(node.parentId)) {
        childrenMap.set(node.parentId, []);
      }
      childrenMap.get(node.parentId).push(node);
    }

    // Recursive count function using the map: O(n) worst case
    const countChildren = (nodeId) => {
      const children = childrenMap.get(nodeId) || [];
      return children.reduce((acc, child) => {
        return acc + 1 + countChildren(child.id);
      }, 0);
    };

    return countChildren(id);
  };
  const indirectReportsCount = orgData
    ? getIndirectReportsCount(data.id, orgData)
    : 0;

  const isModified =
    modifiedNodeIds?.includes(data.id) || data.isModified === true;

  // const isCurrentUser =  data.email === userMail;
  //highlightedUser indica se l'evidenziazione è attiva o no
  // console.log("stampa: ", data.email);
  // console.log("stampa: ", userMail);
  // console.log("current????", isCurrentUser);
  // const boxShadow = isCurrentUser?isExporting? "5px 5px 15px rgba(0,0,0,0.5)":
  //    "0 0 0 5px rgba(0, 69, 158, 0.79)"
  //   : "5px 5px 15px rgba(0,0,0,0.5)";

  const calculateYears = (worker, dateColumn) => {
    const columnDate = worker[dateColumn];
    const columnDateObj =
      columnDate !== undefined && columnDate !== null
        ? dayjs(columnDate, "YYYY-MM-DD")
        : null;
    const now = dayjs();
    let age = undefined;
    if (columnDateObj) {
      age = now.year() - columnDateObj.year();
      const m = now.month() - columnDateObj.month();
      age =
        m < 0 || (m === 0 && now.date() < columnDateObj.date()) ? age - 1 : age;
    }

    return !isNaN(age) ? age.toString() : "";
  };

  const age = calculateYears(data, "date_of_birth");
  const tenure = calculateYears(data, "hiring_date");

  const spanScore = props.data?.span_score ?? null;
  const layerSpan = props.layerSpan?.span ?? false;
  const layersBelow = props.data?.layers_below ?? null;
  const spanMaxLimit = props.data?.span_max_limit ?? null;

  // special case for managers with layers below = 2, minimum span should be 2
  const minSpan = layersBelow === 2 ? 2 : Math.floor(layersBelow * 0.8);

  const spanColor =
    layerSpan === true
      ? layersBelow === 0
        ? "green"
        : layersBelow === 1 
          ? (spanScore === null || spanMaxLimit === null || (spanScore >= 1 && spanScore <= Math.floor(spanMaxLimit)))
            ? "green"
            : "red"
        : // layersBelow >= 2
          spanScore === null 
            || layersBelow === null 
            || spanMaxLimit === null 
            || (spanScore >= Math.floor(layersBelow) && spanScore <= Math.min(layersBelow * 3, spanMaxLimit))
          ? "green"
          : (spanScore >= minSpan && spanScore < Math.floor(layersBelow)) ||
            (spanScore > Math.min(layersBelow * 3, spanMaxLimit) && spanScore <= spanMaxLimit)
          ? "orange"
          : spanScore < minSpan
            || spanScore > spanMaxLimit
          ? "red"
          : false
      : false;

  //Colors red and green to be changed in the future
  const containerStyle = {
    ...styles.nodeContainer,
    // borderColor: isModified ? "rgb(212, 104, 9)" : "#87cdef",
    borderColor:
      spanColor === "green"
        ? "#317B22"
        : spanColor === "orange"
        ? "#DE9502"
        : spanColor === "red"
        ? "#EA3546"
        : "#87cdef",

    borderLeft:
      spanColor === "green"
        ? "0.4rem solid #317B22"
        : spanColor === "orange"
        ? "0.4rem solid #DE9502"
        : spanColor === "red"
        ? "0.4rem solid #EA3546"
        : "0.4rem solid #87cdef", //#00449e
    // boxShadow: isCurrentUser && !isExporting ?"0 0 0 5px rgba(0, 69, 158, 0.79)":"5px 5px 15px rgba(0,0,0,0.5)",
    boxShadow: "0px 6px 18px rgba(0, 0, 0, 0.25)",
  };

  const reportCountStyle = {
    ...styles.gradeReportsBox,
    justifyContent:
      props.data.grade && !isPrivateHidden ? "space-between" : "end",
  };

  const ceoHLevelIconMapping = [
    { key: "0", icon: Circle0, show: false },
    { key: "1", icon: Circle1, show: false },
    { key: "2", icon: Circle2, show: false },
    { key: "3", icon: Circle3, show: false },
    { key: "4", icon: Circle4, show: false },
    { key: "5", icon: Circle5, show: false },
    { key: "6", icon: Circle6, show: false },
    { key: "7", icon: Circle7, show: false },
    { key: "8", icon: Circle8, show: false },
    { key: "9", icon: Circle9, show: false },
  ];

  const ceoHLevelIcon = ceoHLevelIconMapping.filter(
    (mapping) => mapping.key === props.data?.ceo_h_level?.toString()
  );

  const modifiedFlagStyle = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    backgroundColor:
      spanColor === "green"
        ? "#317B22"
        : spanColor === "orange"
        ? "#DE9502"
        : spanColor === "red"
        ? "#EA3546"
        : "#87cdef",
    transform: "rotate(360deg)",
    position: "absolute",
    left: 0,
    top: 0,
    writingMode: "vertical-rl",
    minHeight: "175px",
    borderTopLeftRadius: "0.5rem",
    borderBottomLeftRadius: "0.5rem",
    color: "#ffffff",
    // letterSpacing:"0.1rem",
    textOrientation: "upright",
    alignItems: "center",
    width: "1rem",
  };

  return (
    <>
      <Box style={containerStyle}>
        {isModified && <Box style={modifiedFlagStyle}>MODIFIED</Box>}
        <Box style={styles.nodeContent}>
          {/* <Box style={styles.imgContainer}> //immagine profilo
          <img
            style={styles.nodeImg}
            src={props.data.imageUrl ? props.data.imageUrl : genericUser}
            alt="Profile"
          />
        </Box> */}

          <Box
            style={{
              ...styles.nodeInfo,
              color:
                props.layerSpan?.span || props.layerSpan?.layer
                  ? "#536279"
                  : "#6691c4",
            }}
          >
            {!isPrivateHidden ? (
              <Box
                style={{
                  ...styles.nodeName,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <p> {props.data.name !== ", " ? props.data.name : ""} </p>
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    visibility: privateVisibilityData.user_role === "manager" && privateVisibilityData.reportsIds.indexOf(props.data.id) === -1 ? "hidden" : "visible"
                  }}
                >
                  {ceoHLevelIcon.map((obj) => {
                    const IconComponent = obj.icon;
                    return <IconComponent key={"level" + props.data.id} />;
                  })}

                  {props.layerSpan?.layer &&
                    props.data?.exceeds_layer_limit !== undefined &&
                    (props.data?.exceeds_layer_limit === null ||
                    props.data?.exceeds_layer_limit === false ? (
                      <Box style={{ ...styles.layerIcon }}>
                        <CheckCircleOutlineIcon style={{ fill: "#317B22" }} />
                      </Box>
                    ) : (
                      <Box style={{ ...styles.layerIcon }}>
                        <ErrorOutlineIcon style={{ fill: "#EA3546" }} />
                      </Box>
                    ))}
                </Box>
              </Box>
            ) : (
              <Box
                style={{
                  ...styles.nodeName,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <p> {props.data.name !== ", " ? props.data.name : ""} </p>

                {props.layerSpan?.layer &&
                  props.data?.exceeds_layer_limit !== undefined &&
                  (props.data?.exceeds_layer_limit === null ||
                  props.data?.exceeds_layer_limit === false ? (
                    <Box style={{ ...styles.layerIcon }}>
                      <CheckCircleOutlineIcon style={{ fill: "#317B22" }} />
                    </Box>
                  ) : (
                    <Box style={{ ...styles.layerIcon }}>
                      <ErrorOutlineIcon style={{ fill: "#EA3546" }} />
                    </Box>
                  ))}
              </Box>
            )}
            <Box style={styles.nodeRole}>{props.data.role}</Box>
            <Box style={styles.nodeJobFunction}>
              {/* {props.data.job_function}-{props.data.department} */}
              {props.data.department}
            </Box>
          </Box>
        </Box>
        {!isPrivateHidden ? (
          <Box
            style={{
              ...styles.nodeInfo,
              color:
                props.layerSpan?.span || props.layerSpan?.layer
                  ? "#536279"
                  : "#6691c4",
            }}
          >
            <Box style={{
              ...styles.sensibleInfoBox, 
              visibility: privateVisibilityData.user_role === "manager" && privateVisibilityData.reportsIds.indexOf(props.data.id) === -1 ? "hidden" : "visible"
            }}>
              {age && (
                <Box style={styles.iconBox}>
                  <MdAccountBox size="1.25em" />
                  <p> {age} yo </p>
                </Box>
              )}
              {tenure && (
                <Box style={styles.iconBox}>
                  <MdWorkHistory size="1.25em" />
                  <p> {tenure} years in Epta </p>
                </Box>
              )}
            </Box>
            <Box style={reportCountStyle}>
              {props.data.grade && (
                <Box style={{
                  ...styles.iconBox, 
                  visibility: privateVisibilityData.user_role === "manager" && privateVisibilityData.reportsIds.indexOf(props.data.id) === -1 ? "hidden" : "visible"
                }}> 
                  {props.data.grade}
                </Box>
              )}
              <Box
                style={{
                  ...styles.diagramIconBox,
                  color:
                    props.layerSpan?.span || props.layerSpan?.layer
                      ? "#374151"
                      : "#6691c4",
                }}
              >
                <p>
                  {" "}
                  {directReportsCount}, {indirectReportsCount}{" "}
                </p>
                <BsDiagram3Fill sx={styles.layersIcon} />
              </Box>
            </Box>
          </Box>
        ) : (
          <Box style={styles.nodeInfo}>
            <Box style={reportCountStyle}>
              <Box
                style={{
                  ...styles.diagramIconBox,
                  color:
                    props.layerSpan?.span || props.layerSpan?.layer
                      ? "#575c60ff"
                      : "#6691c4",
                }}
              >
                <p>
                  {" "}
                  {directReportsCount}, {indirectReportsCount}{" "}
                </p>
                <BsDiagram3Fill sx={styles.layersIcon} />
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};

export default CustomNodeContent;
